import type { RegisteredPost } from "@/lib/post";

export default {
  __type: "post",
  published: true,
  author: "Zach Garrett",
  title: "Properties of Trajectory-Affordance",
  tags: ["agency", "formal methods"],
  summary:
    "Derived properties and interpretations of Trajectory-Affordance",
  posts: {},
} satisfies RegisteredPost;
